// src/api/procurement.js
import axios from "axios";

const API_BASE_URL = "https://ims.holdthechild.net/api";

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};



// ================== RFQ ==================
const getRFQs = async () => {
  const res = await axios.get(`${API_BASE_URL}/RFQs`, { headers: getAuthHeaders() });
  return res.data;
};

const createRFQ = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/RFQs`, data, { headers: getAuthHeaders() });
  return res.data;
};

const updateRFQ = async (id, data) => {
  const res = await axios.put(`${API_BASE_URL}/RFQs/${id}`, data, { headers: getAuthHeaders() });
  return res.data;
};

const deleteRFQ = async (id) => {
  const res = await axios.delete(`${API_BASE_URL}/RFQs/${id}`, { headers: getAuthHeaders() });
  return res.data;
};

// ================== RFP ==================
const getRFPs = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/rfps`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (err) {
    console.error("Error fetching RFPs:", err.response?.data || err.message);
    throw err;
  }
};

const createRFP = async (data) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/rfps`, data, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (err) {
    console.error("Error creating RFP:", err.response?.data || err.message);
    throw err;
  }
};

const updateRFP = async (id, data) => {
  try {
    const res = await axios.put(`${API_BASE_URL}/rfps/${id}`, data, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (err) {
    console.error(`Error updating RFP ${id}:`, err.response?.data || err.message);
    throw err;
  }
};

const deleteRFP = async (id) => {
  try {
    const res = await axios.delete(`${API_BASE_URL}/rfps/${id}`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (err) {
    console.error(`Error deleting RFP ${id}:`, err.response?.data || err.message);
    throw err;
  }
};

// ================== BOQ ==================
const getBOQs = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/boqs`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (err) {
    console.error("Error fetching Purchase Orders (BOQs):", err.response?.data || err.message);
    throw err;
  }
};

const createBOQ = async (data) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/boqs`, data, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (err) {
    console.error("Error creating Purchase Order (BOQ):", err.response?.data || err.message);
    throw err;
  }
};

const updateBOQ = async (id, data) => {
  try {
    const res = await axios.put(`${API_BASE_URL}/boqs/${id}`, data, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (err) {
    console.error(`Error updating Purchase Order ${id}:`, err.response?.data || err.message);
    throw err;
  }
};

const deleteBOQ = async (id) => {
  try {
    const res = await axios.delete(`${API_BASE_URL}/boqs/${id}`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (err) {
    console.error(`Error deleting Purchase Order ${id}:`, err.response?.data || err.message);
    throw err;
  }
};

// ================== Proposals ==================
const getProposalsByRFQId = async (rfqId) => {
  try {
    const res = await axios.get(`${API_BASE_URL}/vendor-submissions?rfqId=${rfqId}`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (err) {
    console.error(`Error fetching proposals for RFQ ${rfqId}:`, err.response?.data || err.message);
    throw err;
  }
};

// ================== Purchase Orders ==================
const getPOs = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/purchase-orders`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (err) {
    console.error("Error fetching POs:", err.response?.data || err.message);
    throw err;
  }
};

const createPO = async (data) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/purchase-orders`, data, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (err) {
    console.error("Error creating PO:", err.response?.data || err.message);
    throw err;
  }
};

const updatePO = async (id, data) => {
  try {
    const res = await axios.put(`${API_BASE_URL}/purchase-orders/${id}`, data, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (err) {
    console.error(`Error updating PO ${id}:`, err.response?.data || err.message);
    throw err;
  }
};

const deletePO = async (id) => {
  try {
    const res = await axios.delete(`${API_BASE_URL}/purchase-orders/${id}`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (err) {
    console.error(`Error deleting PO ${id}:`, err.response?.data || err.message);
    throw err;
  }
};

// ================== Vendor ==================
// The getVendors function has been moved here.
const getVendors = async () => {
  try {
    const res = await axios.get(`${API_BASE_URL}/vendors`, {
      headers: getAuthHeaders(),
    });
    return res.data;
  } catch (err) {
    console.error("Error fetching vendors:", err.response?.data || err.message);
    throw err;
  }
};

// Consolidate all exports into one statement
export {
  getRFQs,
  createRFQ,
  updateRFQ,
  deleteRFQ,
  getRFPs,
  createRFP,
  updateRFP,
  deleteRFP,
  getBOQs,
  createBOQ,
  updateBOQ,
  deleteBOQ,
  getProposalsByRFQId,
  getPOs,
  createPO,
  updatePO,
  deletePO,
  getVendors,
};
